<template>
  <div class="p-4 bg-white radius-1 border-1 border-gray-4">
    <div v-html="card.image"></div>

    <h3>{{ card.title }}</h3>

    <p>
      <strong>
        <template v-if="card.bonus_type === 'cash'">
          ${{ card.bonus_amount | number }}
        </template>
        <template v-else>
          {{ card.bonus_amount | number }} {{ card.bonus_type }}
        </template>
      </strong>
      <span>
        after you spend ${{ card.minimum_spend | number }}
        <template v-if="+card.timeframe">
          in {{ card.timeframe }} months
        </template>
      </span>
    </p>

    <div class="flex justify-content-between">
      <a
        :href="card.application_url"
        target="_blank"
        @click="$emit('setReminder', card)"
      >
        Apply Now
      </a>
      <!-- <RouterLink :to="'/card-' + card.id">More Details</RouterLink> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      required: true
    }
  }
};
</script>
